import { useId } from 'react';

// The one section container (ENTRAID-347 redesign, brand/onguard/README.md "Section card"): the KPI card surface
// (.card: white, 1 px line, 16 px radius, 24 px padding, no shadow) with a header row of a 16 px semibold title, an
// optional one-line muted description and a right-aligned link or control. One job per card.

/**
 * @param {{
 *   title?: import('react').ReactNode, description?: import('react').ReactNode, action?: import('react').ReactNode,
 *   headingLevel?: 2|3, as?: string, id?: string, className?: string, bodyClassName?: string,
 *   children?: import('react').ReactNode, testId?: string, ariaLabel?: string,
 * }} props
 * Without a title the card is a plain surface; pass `ariaLabel` when it still needs a name.
 */
export default function SectionCard({
  title = null, description = null, action = null, headingLevel = 2, as: Tag = 'section', id,
  className = '', bodyClassName = '', children, testId, ariaLabel,
}) {
  const titleId = useId();
  const Heading = headingLevel === 3 ? 'h3' : 'h2';
  const named = title != null;
  return (
    <Tag
      id={id}
      className={`card min-w-0 ${className}`.trim()}
      aria-labelledby={named ? titleId : undefined}
      aria-label={!named ? ariaLabel : undefined}
      data-testid={testId}
      data-section-card=""
    >
      {named || action ? (
        <div className="mb-3.5 flex flex-wrap items-baseline gap-x-3 gap-y-1">
          {named ? <Heading id={titleId}>{title}</Heading> : null}
          {description ? <p className="text-[13.5px] text-ipc-muted">{description}</p> : null}
          {action ? <div className="ml-auto text-[13.5px] font-semibold" data-section-action="">{action}</div> : null}
        </div>
      ) : null}
      <div className={bodyClassName}>{children}</div>
    </Tag>
  );
}
